<template>
    <div class="customer-notes">
        <DCard>
            <DRow>
                <DCol>
                    <DTable
                        :items="customerNotes"
                        :fields="fields"
                    >
                        <template #createdAt="{item}">
                            <td>
                                <span class="text-break">
                                    {{ setDateFormat(item.createdAt, 'YYYY-MM-DD hh:mm') }}
                                </span>
                            </td>
                        </template>
                        <template #updatedAt="{item}">
                            <td>
                                <span class="text-break">
                                    {{ setDateFormat(item.updatedAt, 'YYYY-MM-DD hh:mm') }}
                                </span>
                            </td>
                        </template>
                        <template #isSticky="{item}">
                            <td>
                                <DBadge
                                    :color="item.isSticky ? 'success' : 'danger'"
                                >
                                    {{ stickyTranslation(item) }}
                                </DBadge>
                            </td>
                        </template>
                        <template #note="{item}">
                            <td>
                                <span class="text-break">
                                    <NoteContent :note-parts="item.note" />
                                </span>
                            </td>
                        </template>
                        <template #actions="{item}">
                            <td style="display: flex; grid-gap: 10px">
                                <DButton
                                    v-if="userPermissions.includes('customer.comment')"
                                    icon="pencil"
                                    mini
                                    @click="$inertia.get(editRoute(item))"
                                />
                                <DButton
                                    v-if="userPermissions.includes('customer.comment')"
                                    icon="trash-can-outline"
                                    color="danger"
                                    mini
                                    :disabled="isInLoadingState"
                                    @click="deleteNote(item)"
                                />
                            </td>
                        </template>
                    </DTable>
                </DCol>
            </DRow>
            <DFabs>
                <s-s-o-fab
                    :customer="customer"
                    @open-modal="showCreateCloudpitCustomerModal = true"
                    @close-modal="showCreateCloudpitCustomerModal = false"
                />
                <DFab
                    v-if="userPermissions.includes('customer.comment')"
                    icon="plus"
                    :label="__('customers.customer_notes.add')"
                    @click="$inertia.get($route('customers.customers.customer-notes.create', {customer: customer.id}))"
                />
            </DFabs>

            <DModal
                v-model:show="showConfirmationModal"
                :title="__('customers.customer_notes.confirmation_modal.title')"
                :message="__('customers.customer_notes.confirmation_modal.message')"
                is-confirm
                is-error
                @close="closeModal"
                @confirm="deleteCallBack()"
            />
            <CreateCloudPitCustomerModal
                :customer="customer"
                :show-modal="showCreateCloudpitCustomerModal"
                @close-modal="showCreateCloudpitCustomerModal = false"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'
import SSOFab from '~@/Components/Customers/SSOFab'
import CreateCloudPitCustomerModal from '~@/Components/Customers/CreateCloudPitCustomerModal'
import NoteContent from '~@/Components/Customers/NoteContent'

export default {
    name: 'CustomerNotesIndex',
    components: { NoteContent, CreateCloudPitCustomerModal, SSOFab },
    layout: [App, CustomerBase],
    props: {
        customerNotes: {
            type: Array,
            default: () => { return [] }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'createdAt', label: this.__('customers.customer_notes.created_at') },
                { key: 'updatedAt', label: this.__('customers.customer_notes.updated_at') },
                { key: 'note', label: this.__('customers.customer_notes.note') },
                { key: 'isSticky', label: this.__('customers.customer_notes.is_sticky') },
                { key: 'user', label: this.__('customers.customer_notes.user') },
                { key: 'actions', label: '' }
            ],
            showConfirmationModal: false,
            deleteCallBack: () => { return {} },
            showCreateCloudpitCustomerModal: false
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        stickyTranslation (item) {
            return item.isSticky ? this.__('customers.common.yes') : this.__('customers.common.no')
        },
        editRoute (customerNote) {
            return this.$route('customers.customers.customer-notes.edit', {
                customer: this.customer.id,
                customer_note: customerNote.id
            })
        },
        deleteNote (customerNote) {
            this.deleteCallBack = () => {
                this.$inertia.delete(
                    this.$route('customers.customers.customer-notes.destroy', {
                        customer: customerNote.customerId,
                        customer_note: customerNote.id
                    }),
                    {
                        preserveScroll: true
                    }
                )
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        closeModal () {
            this.showConfirmationModal = false
            this.deleteCallBack = () => { return {} }
        }
    }
}
</script>
